import { Model } from 'pinia-orm';
import {
    latestApplicationsInflux,
    newApplicationsInfluxDays,
    newApplicationsInfluxThreshold
} from '../services/SystemParameterService';
import {normalizeJson} from "../../shared/helpers";

export default class SystemParameter extends Model {
    static get entity () {
        return 'system_parameters';
    }

    static fields () {
        return {
            id: this.uid(),
            key: this.attr(''),
            value: this.attr(''),
        }
    }

    static fetchNewApplicationsInfluxDays() {
        return newApplicationsInfluxDays()
            // .then((data) => this.save([data]));
    }

    static fetchNewApplicationsInfluxThreshold() {
        return newApplicationsInfluxThreshold()
            // .then((data) => this.save([data]));
    }

    static fetchLatestApplicationsInflux() {
        return latestApplicationsInflux()
            // .then((data) => this.save([data]));
    }
}
